import { gql } from "@apollo/client";

export const GET_RELATED_ARTICLES_FOR_CATEGORY = gql`
  query GetCategories($filters: CategoryFiltersInput) {
    categories(filters: $filters) {
      data {
        attributes {
          name
          slug
          articles {
            data {
              id
              attributes {
                title
                publishedAt
                content
                description
                slug
                image {
                  data {
                    attributes {
                      url
                      width
                      height
                      name
                      blurhash
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
